import { useParams } from 'react-router-dom';
import ClientForm from './ClientForm';

// Wrapper component to pass approvalId to ClientForm
const ApprovalReviewWrapper: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    return <ClientForm approvalId={id} viewMode={true} />;
};

export default ApprovalReviewWrapper;
